import React from "react";
import { Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import SectionLayout from "../common/SectionLayout";
import Breadcrumb from "../common/Breadcrumb";
import { CLIENT_PROJECTS, PERSONAL_PROJECTS } from "../../data/projects";
import { SECTION_TITLES } from "../../config/constants";
function Projects() {
  return (
    <SectionLayout className="project-section">
      <Breadcrumb />
      <h1 className="project-heading">
          {SECTION_TITLES.projects.client.split(' ').slice(0, 2).join(' ')} <strong className="purple">{SECTION_TITLES.projects.client.split(' ').slice(2).join(' ')}</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are some projects I've worked on as a freelancer for clients.
        </p>
        <Row>
          {CLIENT_PROJECTS.map((project) => (
            <Col key={project.id} md={4} className="project-card">
              <ProjectCard
                imgPath={project.image}
                isBlog={project.isBlog}
                title={project.title}
                description={project.description}
                ghLink={project.githubLink}
                h={project.imageConfig?.h}
                m={project.imageConfig?.m}
                w={project.imageConfig?.w}
              />
            </Col>
          ))}
        </Row>
        
        <h1 className="project-heading">
          <strong className="purple">{SECTION_TITLES.projects.personal.split(' ')[0]} </strong>{SECTION_TITLES.projects.personal.split(' ').slice(1).join(' ')}
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {PERSONAL_PROJECTS.map((project) => (
            <Col key={project.id} md={4} className="project-card">
              <ProjectCard
                imgPath={project.image}
                isBlog={project.isBlog}
                title={project.title}
                description={project.description}
                ghLink={project.githubLink}
                h={project.imageConfig?.h}
                m={project.imageConfig?.m}
                w={project.imageConfig?.w}
              />
            </Col>
          ))}
        </Row>
    </SectionLayout>
  );
}

export default Projects;
